<template>
  <image-header-page :image-header-props="imageHeaderProps" :sticky-header="stickyHeader">
    <template v-slot:header>
      <slot v-if="hasHeaderSlot" name="header"/>
      <div v-else class="banner-page-header ri-large-headline" :style="headerStyles">
        {{ imageHeaderProps.title }}
      </div>
    </template>
    <slot class="flex-1"/>
  </image-header-page>
</template>

<script>
import ImageHeaderPage from './ImageHeaderPage';
import Colors from '../scss/riseup-js-colors.module.scss';
import { ImageHeaderProps } from '../components/ImageHeader';

// eslint-disable-next-line no-unused-vars
const { imgHeight, bottomSeparator, ...otherImageHeaderProps } = ImageHeaderProps;

export default {
  name: 'BannerPage',
  components: {
    ImageHeaderPage,
  },
  props: {
    ...otherImageHeaderProps,
    stickyHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    imageHeaderProps() {
      const { title, imgSrc, textColor, backgroundColor, backgroundPosition } = this.$props;
      return {
        imgHeight: 130,
        bottomSeparator: false,
        title,
        imgSrc,
        textColor,
        backgroundColor,
        backgroundPosition,
      };
    },
    headerStyles() {
      return {
        color: this.textColor ?? Colors.riseupWhite,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/spacings";

.banner-page-header {
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
  padding-left: $ri-spacing-sm;
  font-family: SimplerProAlte, sans-serif;
  text-align: right;
  align-items: center;
  white-space: pre-line;
}

</style>
